import type { RouteObject } from "react-router-dom";
import { addSlashes } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import {
  MsTasks,
  MsTaskBoard,
  MsTaskDetail,
  MsTaskRedirect,
} from "@/utils/lazyLoadComponents";

export enum MS_TASKS_PATH_SEGMENTS {
  ROOT = "project-management",
  PROJECT_BOARD = "board/:projectId",
  // Relative to PROJECT_BOARD — task detail nested under its board so the
  // breadcrumb trail reads Project Management › Board › Task.
  DETAILS = "task/:taskId",
  // Project-less deep link (notifications carry only the task id). Resolves the
  // task's board, then redirects to the canonical nested DETAILS route.
  TASK_REDIRECT = "t/:taskId",
}

export const mySpaceTasksRoutes: RouteObject = {
  path: MS_TASKS_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Project Management" },
  HydrateFallback: Spinner,
  children: [
    { index: true, Component: MsTasks },
    {
      // No breadcrumb — this only ever redirects, never renders a page.
      path: MS_TASKS_PATH_SEGMENTS.TASK_REDIRECT,
      Component: MsTaskRedirect,
    },
    {
      path: MS_TASKS_PATH_SEGMENTS.PROJECT_BOARD,
      handle: { breadcrumb: "Board" },
      children: [
        { index: true, Component: MsTaskBoard },
        {
          path: MS_TASKS_PATH_SEGMENTS.DETAILS,
          handle: { breadcrumb: "Task" },
          Component: MsTaskDetail,
        },
      ],
    },
  ],
};

export const MS_TASKS_PATHS = Object.freeze({
  ROOT: addSlashes(MS_TASKS_PATH_SEGMENTS.ROOT),
  PROJECT_BOARD: (projectId: string | number) =>
    addSlashes(MS_TASKS_PATH_SEGMENTS.ROOT, "board", String(projectId)),
  DETAIL: (projectId: string | number, taskId: string | number) =>
    addSlashes(
      MS_TASKS_PATH_SEGMENTS.ROOT,
      "board",
      String(projectId),
      "task",
      String(taskId),
    ),
  // Project-less deep link used by notifications; resolves to DETAIL.
  TASK_REDIRECT: (taskId: string | number) =>
    addSlashes(MS_TASKS_PATH_SEGMENTS.ROOT, "t", String(taskId)),
});
